/*
*
* File JS per la Homepage
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroFullSlider from 'components/hero-full-slider/hero-full-slider';
import bigButtons from 'components/block-big-buttons/block-big-buttons';
import imgTextFull from 'components/block-img-text-full/block-img-text-full';
import highlightSlider from 'components/block-highlight-slider/block-highlight-slider';
import promoList from 'components/lists/promo-list/promo-list';
import blockImage from 'components/block-image/block-image';
import marchiSlider from 'components/block-marchi-slider/block-marchi-slider';
import blockNews from 'components/block-news/block-news';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

heroFullSlider();
highlightSlider();
marchiSlider();

//--------------------------------------------------------------------//